import React from "react";
import { RouteComponentProps } from "react-router-dom";
import classes from "../styles/Maintenance.module.scss";
import { Typography } from "@material-ui/core";
import MaintenanceVisual from "../images/MaintenanceVisual";

interface ComponentProps {}

interface StateProps {}

interface DispatchProps {}

type Props = StateProps & DispatchProps & ComponentProps & RouteComponentProps;

const Maintenance: React.FC<Props> = () => {
  return (
    <div className={classes.maintenanceRoot}>
      <div className={classes.visual}>
        <MaintenanceVisual />
      </div>
      <div className={classes.header}>
        <Typography variant="h3" className={classes.headerTypography}>
          Suralink is undergoing
          <br /> scheduled maintenance.
        </Typography>
      </div>
      <div className={classes.subtext}>
        <Typography
          variant="body2"
          style={{ color: "#383E55", textAlign: "center" }}
        >
          Please see&nbsp;
          <a
            target="_blank"
            rel="noreferrer"
            href="https://status.suralink.com"
          >
            status.suralink.com
          </a>
          &nbsp;for more information.
        </Typography>
      </div>
    </div>
  );
};

export default Maintenance;
